// src/components/ArticleCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Calendar, Eye, Heart, Share2 } from 'lucide-react';

const ArticleCard = ({ article }) => {
  return (
    <Card className="group overflow-hidden hover:shadow-lg transition-all duration-300 border-border">
      {article.thumbnail && (
        <div className="relative h-52 overflow-hidden">
          <img
            src={article.thumbnail}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}

      <CardContent className="p-6">
        <h3 className="text-xl font-semibold leading-tight mb-3 line-clamp-2">
          <Link 
            to={`/blog/${article.id}`} 
            className="hover:text-primary transition-colors"
          >
            {article.title}
          </Link>
        </h3>

        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-4">
          <span>By {article.author_username}</span>
          <span>•</span>
          <div className="flex items-center gap-1">
            <Calendar className="h-4 w-4" />
            {new Date(article.created_at).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric'
            })}
          </div>
        </div>

        <p className="text-muted-foreground line-clamp-3 mb-5 text-[15px]">
          {article.excerpt}
        </p>

        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-1">
              <Eye className="h-4 w-4" />
              <span>{article.view_count || 0}</span>
            </div>
            <div className="flex items-center gap-1">
              <Heart className="h-4 w-4" />
              <span>{article.likes_count || 0}</span>
            </div>
            <div className="flex items-center gap-1">
              <Share2 className="h-4 w-4" />
              <span>{article.shares_count || 0}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ArticleCard;
